module.exports = __webpack_public_path__ + "media/UnauthRightCard.fac9dbe1.mp4";